import PubSub from 'services/PubSub/';
import AddressService from 'services/Address/';

const  _setDeliveryMode = (method, value, sc, oldAddress, refresh) => {
    return AddressService.setDeliveryMode(method, value, sc, oldAddress, refresh).then(results => {
        if (results) {

            PubSub.dispatch('change-delivery-mode', {
                results
            });
            return results;
        }
    });
}

const actions = {
    setDeliveryMode(method, value, sc, oldAddress, refresh = true) {

        const selectedAddress = {"addressType":"residential","receiverName":"","postalCode":"8320000","city":"Santiago","state":"REGIÓN METROPOLITANA","country":"CHL","street":"Avenida Presidente Kennedy","number":"9001","neighborhood":"Santiago","complement":"","reference":"","geoCoordinate":[-70.5462013,-33.3908833],"addressId":"q9f6zuh4v3fcfsnwc9mkm1563398193834","geoCoordinates":[-70.5462013,-33.3908833]};
        const availableAddresses = [{"addressType":"residential","receiverName":"","postalCode":"8320000","city":"Santiago","state":"REGIÓN METROPOLITANA","country":"CHL","street":"Avenida Presidente Kennedy","number":"9001","neighborhood":"Santiago","complement":"","reference":"","geoCoordinate":[-70.5462013,-33.3908833],"addressId":"q9f6zuh4v3fcfsnwc9mkm1563398193834","geoCoordinates":[-70.5462013,-33.3908833]},{"addressType":"residential","receiverName":"","postalCode":"8320000","city":"Santiago","state":"REGIÓN METROPOLITANA","country":"CHL","street":"Presidente kennedy","number":"99","neighborhood":"Santiago","complement":"","reference":"","geoCoordinate":[-70.54683019999999,-33.3927166],"addressId":"otm4nh5e8tbg0o1rebeesk1563398133175"},{"addressType":"residential","receiverName":"","postalCode":"8320000","city":"Santiago","state":"REGIÓN METROPOLITANA","country":"CHL","street":"Moneda","number":"2180","neighborhood":"Santiago","complement":"12","reference":"Mi casa","geoCoordinate":[-70.66609499999998,-33.4435206],"addressId":"ux1mtr8c9bidnmcny351555608733142"}];

        return AddressService.applyAddress(selectedAddress, availableAddresses).then(() => {
            return _setDeliveryMode(method, value, sc, oldAddress, refresh);
        });
    }
};

export default actions;
